// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'
import { SITE_NAME, DEFAULT_KEYWORDS } from './router'

/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'
import './assets/css/tech-theme.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

Vue.config.productionTip = false


/* 动态写入 <meta name="..."> 内容，缺失则创建 */
function setMeta(name, content) {
  if (!content) return
  var el = document.querySelector('meta[name="' + name + '"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.getElementsByTagName('head')[0].appendChild(el)
  }
  el.setAttribute('content', content)
}

router.beforeEach((to, from, next) => {
    var meta = to.meta || {}
    document.title = meta.title ? (meta.title + ' | ' + SITE_NAME) : SITE_NAME
    setMeta('description', meta.description)
    setMeta('keywords', meta.keywords || DEFAULT_KEYWORDS)
    next();
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js